import React, { PropsWithChildren } from "react";

import { Navigate, Outlet } from "react-router";

import { useOrganizationAppContext } from "@services/application/useApplicationContext";

export default function ProOrganizationOnly({ children }: PropsWithChildren) {
  // check that the organization is not LITE
  const { organization } = useOrganizationAppContext();
  if (organization?.currentPlan === "LITE") {
    return <Navigate to="/showroom" replace />;
  }

  return children;
}

export function ProOrganizationOnlyLayout() {
  return (
    <ProOrganizationOnly>
      <Outlet />
    </ProOrganizationOnly>
  );
}
